import WorkItemListPagingResultModelBase from '../_generated/modelBases/work-item-list-paging-result-model-base';

export default class WorkItemListPagingResultModel extends WorkItemListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
